import type { Action } from 'redux';

export const CLEAR_APP_STORE = 'CLEAR_APP_STORE' as const;

export const clearAppStore = () => ({ type: CLEAR_APP_STORE });

export type ClearAppStoreResponseAction = Action<typeof CLEAR_APP_STORE>;
